"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSessionData = saveSessionData;
exports.saveSessionDataWithBeacon = saveSessionDataWithBeacon;
exports.loadSessionData = loadSessionData;
const client_1 = require("../session/client/index.js");
async function saveSessionData(calculatorId, answers, matches, calculatorVersion) {
    const headers = {
        "Content-Type": "application/json",
    };
    const sessionId = (0, client_1.getRuntimeSessionId)();
    if (sessionId) {
        headers.Authorization = `Bearer ${sessionId}`;
    }
    const response = await fetch(`/api/calculators/${calculatorId}/session-data`, {
        method: "POST",
        headers,
        credentials: "include",
        body: JSON.stringify({ answers, matches, calculatorVersion }),
    });
    if (!response.ok) {
        throw response;
    }
}
async function saveSessionDataWithBeacon(calculatorId, answers, matches, calculatorVersion) {
    const url = `/api/calculators/${calculatorId}/session-data`;
    const data = JSON.stringify({ answers, matches, calculatorVersion });
    if (navigator.sendBeacon) {
        const blob = new Blob([data], { type: "application/json" });
        const success = navigator.sendBeacon(url, blob);
        if (success) {
            return;
        }
    }
    return await saveSessionData(calculatorId, answers, matches, calculatorVersion);
}
async function loadSessionData(calculatorId) {
    const headers = {};
    const sessionId = (0, client_1.getRuntimeSessionId)();
    if (sessionId) {
        headers.Authorization = `Bearer ${sessionId}`;
    }
    const response = await fetch(`/api/calculators/${calculatorId}/session-data`, {
        headers,
        credentials: "include",
    });
    if (!response.ok) {
        throw response;
    }
    try {
        const data = await response.json();
        return {
            answers: data.answers,
            matches: data.matches,
            calculatorVersion: data.calculatorVersion,
        };
    }
    catch {
        throw new Error("Failed to parse session data response");
    }
}
